/**
 * Use this to perform an action with a click and apply status to the button
 *
 * Usage:
 *
 *      <span data-bind="clickPromise:promiseReturningFn">GO</span>
 */
define('ko/customBinding/clickPromise',['knockout', 'bluebird'], function(ko, Promise) {

    ko.bindingHandlers.clickPromise = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var callback = valueAccessor(),
                inProgress = ko.observable(false);

            ko.applyBindingsToNode(
                element,
                {
                    click: function() {

                        if (inProgress()) {
                            return;
                        }

                        inProgress(true);

                        Promise.resolve(callback()).finally(function() {
                            inProgress(false);
                        });

                    },
                    css: {
                        loading: inProgress
                    }
                },
                bindingContext
            );

        }
    };

});

